import { render, staticRenderFns } from "./TabHandovered.vue?vue&type=template&id=b579a226&"
import script from "./TabHandovered.vue?vue&type=script&lang=js&"
export * from "./TabHandovered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports